export default __webpack_public_path__ + "static/media/aiv1_faceTraining.7937f47e.GIF";